import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-portal-support-info',
  templateUrl: './portal-support-info.component.html',
  styleUrls: ['./portal-support-info.component.scss', './portal-support-info.component.en.scss']
})
export class PortalSupportInfo {
  @Input() data: any;
}
